import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import API from "../../../Network/API";

const emptyForm = {
    user_id: "",
    date: "",
    remark: "",
    alarms: {},
    assets: {},
};

export default function SitePm() {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({ users: [], alarms: [], assets: [] });
    const [form, setForm] = useState(emptyForm);

    const loadList = () => {
        setLoading(true);
        API.get(`/v1/oauth/site_pm?site_id=${encodeURIComponent(id)}`)
            .then((response) => setRows(response.data?.data?.pms || []))
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (id) loadList();
    }, [id]);

    const openAdd = () => {
        setShowModal(true);
        setForm(emptyForm);
        setFormLoading(true);
        API.get(`/v1/oauth/site_pm/create?site_id=${encodeURIComponent(id)}`)
            .then((response) => {
                setFormData({
                    users: response.data?.data?.users || [],
                    alarms: response.data?.data?.alarms || [],
                    assets: response.data?.data?.assets || [],
                });
            })
            .catch(() => alert("Could not load PM form"))
            .finally(() => setFormLoading(false));
    };

    const toggleRow = (group, key) => {
        setForm((prev) => {
            const current = prev[group][key] || { checked: false, remark: "" };
            return {
                ...prev,
                [group]: {
                    ...prev[group],
                    [key]: { ...current, checked: !current.checked },
                },
            };
        });
    };

    const setRemark = (group, key, remark) => {
        setForm((prev) => {
            const current = prev[group][key] || { checked: false, remark: "" };
            return {
                ...prev,
                [group]: {
                    ...prev[group],
                    [key]: { ...current, remark },
                },
            };
        });
    };

    const savePm = (event) => {
        event.preventDefault();
        if (!form.user_id) {
            alert("PM User is required");
            return;
        }
        const alarmIds = Object.keys(form.alarms).filter((key) => form.alarms[key].checked);
        const assetIds = Object.keys(form.assets).filter((key) => form.assets[key].checked);
        const alarmRemark = {};
        const assetRemark = {};
        alarmIds.forEach((key) => { alarmRemark[key] = form.alarms[key].remark || ""; });
        assetIds.forEach((key) => { assetRemark[key] = form.assets[key].remark || ""; });

        setSaving(true);
        API.post("/v1/oauth/site_pm", {
            site_id: id,
            user_id: form.user_id,
            date: form.date,
            remark: form.remark,
            alarm_id: alarmIds,
            asset_id: assetIds,
            alarm_remark: alarmRemark,
            asset_remark: assetRemark,
        })
            .then((response) => {
                alert(response.data?.message || "PM add successfully");
                if (response.data?.success) {
                    setShowModal(false);
                    loadList();
                }
            })
            .catch((error) => {
                alert(error?.response?.data?.message || "Could not save PM");
            })
            .finally(() => setSaving(false));
    };

    const userOptions = formData.users.map((user) => ({
        value: user.id,
        label: user.phone ? `${user.name} - ${user.phone}` : user.name,
    }));

    return (
        <div className="row ms-1 me-1">
            <div className="col-12">
                <div className="card shadow-sm border-0 bg-cc mt-2">
                    <div className="card-header border-bottom card-title bg-white align-items-center d-flex">
                        <b className="main-card-title mb-0 flex-grow-1">PM</b>
                        <button type="button" className="btn btn-sm btn-success" onClick={openAdd}>
                            <i className="fa-solid fa-plus me-1"></i>
                            Add PM
                        </button>
                    </div>
                    <div className="card-body bg-white">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Date</th>
                                        <th>PM By</th>
                                        <th>Remark</th>
                                        <th>Created By</th>
                                        <th>Total Alarm</th>
                                        <th>Total Asset</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr><td colSpan="7">Loading...</td></tr>
                                    )}
                                    {!loading && rows.length === 0 && (
                                        <tr><td colSpan="7">No PM found</td></tr>
                                    )}
                                    {!loading && rows.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.id}</td>
                                            <td>{row.date}</td>
                                            <td>{row.pm_by || "-"}</td>
                                            <td>{row.remark}</td>
                                            <td>{row.created_by || "-"}</td>
                                            <td>{row.alarm_count}</td>
                                            <td>{row.asset_count}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <form className="modal-content" onSubmit={savePm}>
                            <div className="modal-header">
                                <h5 className="modal-title">Add PM (Site ID: {id})</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                {formLoading ? <p className="mb-0">Loading...</p> : (
                                    <>
                                        <div className="row">
                                            <div className="form-group col-md-6 mb-2">
                                                <label className="form-label">PM User<em className="text-danger">*</em></label>
                                                <Select
                                                    options={userOptions}
                                                    value={userOptions.find((option) => String(option.value) === String(form.user_id)) || null}
                                                    onChange={(option) => setForm((prev) => ({ ...prev, user_id: option?.value || "" }))}
                                                    isSearchable
                                                    isClearable
                                                    placeholder="Select One"
                                                    menuPortalTarget={document.body}
                                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 mb-2">
                                                <label className="form-label">PM Date<em className="text-danger">*</em></label>
                                                <input className="form-control" required type="date" value={form.date} onChange={(e) => setForm((prev) => ({ ...prev, date: e.target.value }))} />
                                            </div>
                                            <div className="form-group col-md-12 mb-2">
                                                <label className="form-label">Remark<em className="text-danger">*</em></label>
                                                <textarea className="form-control" required value={form.remark} onChange={(e) => setForm((prev) => ({ ...prev, remark: e.target.value }))} />
                                            </div>
                                        </div>
                                        <div className="row" style={{ maxHeight: 300, overflow: "auto" }}>
                                            <div className="col-md-6">
                                                <h5>Alarms</h5>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Title</th>
                                                            <th className="text-center">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.alarms.map((alarm) => (
                                                            <tr key={alarm.order_list}>
                                                                <td>
                                                                    <label className="mb-0">
                                                                        <input type="checkbox" className="me-1" checked={!!form.alarms[alarm.order_list]?.checked} onChange={() => toggleRow("alarms", alarm.order_list)} />
                                                                        {alarm.name}
                                                                    </label>
                                                                </td>
                                                                <td>
                                                                    <input className="form-control form-control-sm" value={form.alarms[alarm.order_list]?.remark || ""} onChange={(e) => setRemark("alarms", alarm.order_list, e.target.value)} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-md-6">
                                                <h5>Assets</h5>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Product</th>
                                                            <th>Asset ID</th>
                                                            <th className="text-center">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.assets.map((asset) => (
                                                            <tr key={asset.id}>
                                                                <td>
                                                                    <label className="mb-0">
                                                                        <input type="checkbox" className="me-1" checked={!!form.assets[asset.id]?.checked} onChange={() => toggleRow("assets", asset.id)} />
                                                                        {asset.name}
                                                                    </label>
                                                                </td>
                                                                <td>{asset.asset_number}</td>
                                                                <td>
                                                                    <input className="form-control form-control-sm" value={form.assets[asset.id]?.remark || ""} onChange={(e) => setRemark("assets", asset.id, e.target.value)} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                                <button type="submit" className="btn btn-info text-white" disabled={formLoading || saving}>
                                    {saving ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
